module.exports = __webpack_public_path__ + "img/ore-bronze.5ae79e4b.svg";